import handles_saving from "../../../mixins/HandlesSaving"

const request_for_material_body = {
    mixins: [handles_saving],
    mounted () {
        this.reset_entity()
    },
    watch: {
        revisionEntity: "reset_entity",
        "record.id": "reset_entity"
    },
    methods: {
        reset_entity () {
            this.entity = this.revisionEntity
            this.record_id = this.record ? this.record.id : 0
        }
    },
    props: {
        revisionEntity: {
            type: String,
            required: true
        },
        record: {
            type: Object,
            required: true
        },
        parent: {
            validator: prop => !prop || (typeof prop === "object"),
            required: true
        },
        editable: {
            type: Boolean,
            default: false
        }
    }
}

export default request_for_material_body
